import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/spinner/spinner.component.js'

const tagName = 'dap-ds-spinner'

/**
 * `dap-ds-spinner`
 * @summary Loading spinner component.
 * @element dap-ds-spinner
 * @title - Spinner
 *
 * @csspart base - The main spinner container.
 * @csspart icon - The loading icon element.
 * @csspart icon-base - The base of the loading icon.
 * @csspart text - The loading text element.
 *
 * @slot - The loading text content.
 *
 * @cssprop --dds-spinner-icon-color-neutral - Color for neutral spinner icons.
 * @cssprop --dds-spinner-icon-color-brand - Color for brand spinner icons.
 * @cssprop --dds-spinner-icon-color-negative - Color for negative spinner icons.
 * @cssprop --dds-spinner-icon-color-positive - Color for positive spinner icons.
 * @cssprop --dds-spinner-icon-color-inverted - Color for inverted spinner icons.
 * @cssprop --dds-spinner-text-spacing - Spacing between spinner and text.
 * @cssprop --dds-spinner-animation-duration - Duration of the spinner animation.
 *
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSSpinner',
})

export default reactWrapper
